import { render, staticRenderFns } from "./IframeMegjelenito.vue?vue&type=template&id=0365a807&"
import script from "./IframeMegjelenito.vue?vue&type=script&lang=js&"
export * from "./IframeMegjelenito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports